import { DomHelper } from "./domHelper";
import { getOfficeBackendData, sendOfficeBackendData } from "./xhrbackend";
import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from './appCardDefault';
class OfficeDBStore {
    constructor() {
        this.bearerToken = '';
        this.copiedLocation = null;
        this.isLocationUpdated = false;
        this.lastValueOfSelector = 'empty';
    }
    setBearerToken(bearerToken) {
        this.bearerToken = bearerToken;
    }
    getBearerToken() {
        return this.bearerToken;
    }
    isCopyInProgress() {
        return this.copiedLocation !== null;
    }
    setCopiedLocation(copiedLocation) {
        this.copiedLocation = copiedLocation;
    }
    getCopiedLocation() {
        return this.copiedLocation;
    }
    setIsLocationUpdated(value) {
        this.isLocationUpdated = value;
    }
    getIsLocationUpdated() {
        return this.isLocationUpdated;
    }
    getLastValueOfSelector() {
        return this.lastValueOfSelector;
    }
    setLastValueOfSelector(value) {
        this.lastValueOfSelector = value;
    }
}
const dataStore = new OfficeDBStore();
export function appOfficeDbAdminRender(globalStore, username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appOfficeDbAdminRender");
    const additionalClassList = [];
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, (event) => {
        handleClickOpen(event, username, userResponse.odDeskPreferences);
    });
    dataStore.setBearerToken(bearerToken);
}
export function getOfficeDbAdminMainStructure(fullScreenNode, additionalClassList) {
    const wrapper = DomHelper.appendNode(fullScreenNode, 'div', [], [], "", "odOfficeWrapper");
    DomHelper.appendNode(wrapper, 'h1', additionalClassList, [], "Office Vorlagen Datenbank");
    DomHelper.appendNode(wrapper, 'section', additionalClassList, [], "", "odOfficeFacilitySelector");
    DomHelper.appendNode(wrapper, 'section', ['disabled'], [], "", "odOfficeLocations");
    DomHelper.appendNode(wrapper, 'section', ['disabled'], [{ attr: 'spellcheck', value: 'false' }], "", "odTemplateEditor");
}
function handleClickOpen(event, username, userPreferences) {
    const additionalClassList = [];
    const appGroupNode = document.getElementById('appGroups');
    if (appGroupNode)
        appGroupNode.classList.add('disabled');
    const fullScreenNode = document.getElementById('appFullscreen');
    if (fullScreenNode) {
        fullScreenNode.classList.remove('disabled');
        createButtonClose(fullScreenNode);
        getOfficeDbAdminMainStructure(fullScreenNode, additionalClassList);
        const wrapper = document.getElementById('odOfficeWrapper');
        const odOfficeFacilitySelector = document.getElementById('odOfficeFacilitySelector');
        const selectorNode = createFacilitySelector(odOfficeFacilitySelector);
        const odOfficeLocations = document.getElementById('odOfficeLocations');
        renderLocationTable(odOfficeLocations);
        const odTemplateEditor = document.getElementById('odTemplateEditor');
        renderTemplateEditor(odTemplateEditor);
        getOfficeBackendData("/facilities", "GET", "application/json", dataStore.getBearerToken(), function (response) {
            const responseData = JSON.parse(response.target.response);
            injectDataToFacilitySelector(selectorNode, responseData);
            selectorNode.addEventListener('change', (e) => {
                var _a;
                if (dataStore.isCopyInProgress()) {
                    DomHelper.showMessage({
                        appcn: "",
                        appdn: "",
                        duration: 5000,
                        header: "Error",
                        icon: "fa-circle-exclamation",
                        message: `Bitte schließen Sie den Kopiervorgang ${(_a = dataStore.getCopiedLocation()) === null || _a === void 0 ? void 0 : _a.einrichtungbezeichnung.trim()} ab`,
                        type: 'error',
                        version: ""
                    }, null, dataStore.getBearerToken());
                    selectorNode.value = dataStore.getLastValueOfSelector();
                    return;
                }
                const selectedFacilityId = parseInt(selectorNode.value);
                getOfficeBackendData("/facilities/" + selectedFacilityId + "/locations", "GET", "application/json", dataStore.getBearerToken(), function (response) {
                    const responseData = JSON.parse(response.target.response);
                    console.log(responseData);
                    const tbody = document.getElementById('rudi-officedb-table-body');
                    tbody.setAttribute('table-facility', `${selectedFacilityId}`);
                    odOfficeLocations.classList.remove('disabled');
                    injectDataToLocationTable(tbody, responseData);
                    resetSearchBoxValue();
                });
            });
            selectorNode.addEventListener('focus', () => {
                dataStore.setLastValueOfSelector(selectorNode.value);
            });
        });
    }
}
function renderLocationTable(injectNode) {
    const odOfficeActionBar = DomHelper.appendNode(injectNode, 'section', [], [], "", "odOfficeActionBar");
    const odTopSearchBarWrapper = DomHelper.appendNode(odOfficeActionBar, 'div', [], [], "", "odTopSearchBarWrapper");
    const odSearchReset = DomHelper.appendNode(odTopSearchBarWrapper, 'i', ['fa-light', 'fa-xmark', 'disabled'], [], "", 'search-reset');
    const odSearchbar = DomHelper.appendNode(odTopSearchBarWrapper, 'div', ['top-search-bar'], [{ attr: 'contenteditable', value: 'true' }], '', 'location-search');
    DomHelper.appendNode(odTopSearchBarWrapper, 'i', ['fa-light', 'fa-search']);
    const odSchoolGrid = DomHelper.appendNode(injectNode, 'section', [], [], '', 'odSchoolGrid');
    const table = DomHelper.appendNode(odSchoolGrid, 'table', [], [], '');
    const thead = DomHelper.appendNode(table, 'thead', [], [], '');
    const tr = DomHelper.appendNode(thead, 'tr', [], [], '');
    DomHelper.appendNode(tr, 'th', [], [], 'Einrichtungsbezeichnung');
    DomHelper.appendNode(tr, 'th', [], [], 'Fensterzeile');
    DomHelper.appendNode(tr, 'th', [], [], 'Telefon');
    DomHelper.appendNode(tr, 'th', [], [], 'Telefax');
    DomHelper.appendNode(tr, 'th', [], [], 'Aktionen');
    const tbody = DomHelper.appendNode(table, 'tbody', [], [], '', 'rudi-officedb-table-body');
    addSearchListeners(odSearchbar, odSearchReset, tbody);
}
function createButtonClose(injectNode) {
    const buttonNode = DomHelper.appendNode(injectNode, 'button', ['btn', 'btn-primary', 'mt-2'], [{
            attr: 'id',
            value: 'rudi-officedbadmin-btn-hide'
        }]);
    DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-arrow-up', 'me-1'], []);
    DomHelper.appendNode(buttonNode, 'span', [], [], 'schließen');
    buttonNode.addEventListener('click', function (event) {
        const appGroupNode = document.getElementById('appGroups');
        if (appGroupNode)
            appGroupNode.classList.remove('disabled');
        const fullScreenNode = document.getElementById('appFullscreen');
        if (fullScreenNode) {
            fullScreenNode.innerHTML = "";
            fullScreenNode.classList.add('disabled');
        }
        dataStore.setCopiedLocation(null);
    });
}
function createFacilitySelector(injectNode) {
    const formGroup = DomHelper.appendNode(injectNode, 'div', ['form-group']);
    DomHelper.appendNode(formGroup, 'h3', [], [], 'Bereich Auswahl');
    const label = DomHelper.appendNode(formGroup, 'label', ['form-label', 'mb-0', 'mt-2'], [{ attr: 'for', value: 'rudi-tool-form-office' }], 'Wählen Sie einen Bereich aus');
    const selectNode = DomHelper.appendNode(formGroup, 'select', ['form-select'], [{ attr: 'id', value: 'rudi-tool-form-office' }]);
    DomHelper.appendNode(selectNode, 'option', [], [
        { attr: 'value', value: "empty" },
        { attr: 'disabled', value: 'true' },
        { attr: 'selected', value: 'true' },
        { attr: 'hidden', value: 'true' }
    ], "-- Bitte Bereich auswählen --- ");
    return selectNode;
}
function injectDataToFacilitySelector(selectorNode, data) {
    data.forEach(item => {
        DomHelper.appendNode(selectorNode, 'option', [], [
            { attr: 'value', value: `${item.bereichsid}` }
        ], item.bereichsname);
    });
}
function injectDataToLocationTable(injectNode, data) {
    const fields = ['einrichtungbezeichnung', 'fensterzeile', 'telefon', 'telefax'];
    const fragment = document.createDocumentFragment();
    data.forEach(item => {
        const trNode = DomHelper.appendNode(fragment, 'tr', [], [], '', `${item.einrichtungid}`);
        fields.forEach(field => {
            var _a, _b;
            const value = (_b = (_a = item[field]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '';
            DomHelper.appendNode(trNode, 'td', [], [], value);
        });
        const btnTD = DomHelper.appendNode(trNode, 'td', ['od-button-area'], [], '');
        const duplicateBtn = DomHelper.appendNode(btnTD, 'button', ['btn', 'btn-primary'], [{ attr: 'data-location-id', value: `${item.einrichtungid}` }]);
        DomHelper.appendNode(duplicateBtn, 'i', ['fa-solid', 'fa-clone'], []);
        DomHelper.addToolTip(duplicateBtn, 'Duplizieren Sie diese Einrichtung');
        duplicateBtn.addEventListener('click', (e) => onLocationDuplicateBtnClick(e));
        const locationEditBtn = DomHelper.appendNode(btnTD, 'button', ['btn', 'btn-primary'], [{ attr: 'data-location-id', value: `${item.einrichtungid}` }]);
        DomHelper.appendNode(locationEditBtn, 'i', ['fa-solid', 'fa-edit'], []);
        DomHelper.addToolTip(locationEditBtn, 'Bearbeiten Sie diese Einrichtung');
        locationEditBtn.addEventListener('click', (e) => onLocationEditBtnClick(e, item));
    });
    injectNode.replaceChildren(fragment);
    if (dataStore.isCopyInProgress()) {
        dataStore.setCopiedLocation(null);
    }
}
function addSearchListeners(searchNode, resetIcon, tableBody) {
    searchNode.addEventListener('input', () => {
        var _a, _b;
        const query = (_b = (_a = searchNode.textContent) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()) !== null && _b !== void 0 ? _b : '';
        if (query.length > 0) {
            resetIcon.classList.remove('disabled');
        }
        else {
            resetIcon.classList.add('disabled');
        }
        if (query.length >= 2) {
            filterTable(tableBody, query);
        }
        else {
            filterTable(tableBody, '');
        }
    });
    searchNode.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            return;
        }
    });
    resetIcon.addEventListener('click', () => {
        if (resetIcon.classList.contains('disabled'))
            return;
        searchNode.textContent = '';
        resetIcon.classList.add('disabled');
        filterTable(tableBody, '');
        searchNode.focus();
    });
}
function resetSearchBoxValue() {
    const odSearchbar = document.getElementById('location-search');
    if (!odSearchbar) {
        return;
    }
    odSearchbar.textContent = '';
    const resetSearch = document.getElementById('search-reset');
    if (resetSearch) {
        resetSearch.classList.add('disabled');
    }
}
function onLocationEditBtnClick(e, locationObject) {
    const target = e.currentTarget;
    const locationId = target.getAttribute('data-location-id');
    console.log(`Editing location with ID: ${locationId}`);
    insertLocationDataIntoEditor(locationObject);
}
function onLocationDuplicateBtnClick(e) {
    var _a;
    if (dataStore.isCopyInProgress()) {
        DomHelper.showMessage({
            appcn: "",
            appdn: "",
            duration: 5000,
            header: "Error",
            icon: "fa-circle-exclamation",
            message: `Bitte schließen Sie den Kopiervorgang ${(_a = dataStore.getCopiedLocation()) === null || _a === void 0 ? void 0 : _a.einrichtungbezeichnung.trim()} ab`,
            type: 'error',
            version: ""
        }, null, dataStore.getBearerToken());
        return;
    }
    const target = e.currentTarget;
    const locationId = Number(target.getAttribute('data-location-id'));
    console.log(`Duplicating location with ID: ${locationId}`);
    sendOfficeBackendData('/locations/' + locationId + "/copy", "POST", "application/json", dataStore.getBearerToken(), {}, function (response) {
        const responseStatusCode = response.target.status;
        if (![200, 201].includes(responseStatusCode)) {
            DomHelper.showMessage({
                appcn: "",
                appdn: "",
                duration: 5000,
                header: "Error",
                icon: "fa-circle-exclamation",
                message: "Something went wrong!",
                type: 'error',
                version: ""
            }, null, dataStore.getBearerToken());
            return;
        }
        const responseData = JSON.parse(response.target.response);
        console.log("Location duplicated successfully");
        console.log(responseData);
        dataStore.setCopiedLocation(responseData);
        createNewLocationRow(target, locationId);
    });
}
function createNewLocationRow(target, locationId) {
    const copiedLocation = dataStore.getCopiedLocation();
    const currentRow = target.closest('tr');
    if (!copiedLocation || !currentRow) {
        DomHelper.showMessage({
            appcn: "",
            appdn: "",
            duration: 5000,
            header: "Error",
            icon: "fa-circle-exclamation",
            message: `Ein unerwarteter Fehler ist passiert.`,
            type: 'error',
            version: ""
        }, null, dataStore.getBearerToken());
        return;
    }
    const currentCells = currentRow.querySelectorAll('td');
    const newRow = currentRow.cloneNode(false);
    newRow.classList.add('new-row-highlight');
    newRow.setAttribute('id', `${copiedLocation.einrichtungid}`);
    const keys = ['einrichtungbezeichnung', 'fensterzeile', 'telefon', 'telefax'];
    currentCells.forEach((cell, index) => {
        var _a;
        const newCell = cell.cloneNode(false);
        if (!newCell.classList.contains('od-button-area')) {
            const currentKey = keys[index];
            DomHelper.appendNode(newCell, 'div', ['editable-wrapper'], [{ attr: 'contenteditable', value: 'true' }, { attr: 'data-key', value: currentKey }], `${(_a = copiedLocation[currentKey]) !== null && _a !== void 0 ? _a : ''}`);
        }
        else {
            const locationEditBtn = DomHelper.appendNode(newCell, 'button', ['btn', 'btn-primary'], [{ attr: 'data-location-id', value: `copy` }]);
            DomHelper.appendNode(locationEditBtn, 'i', ['fa-solid', 'fa-edit'], []);
            DomHelper.addToolTip(locationEditBtn, 'Bearbeiten Sie diese Einrichtung');
            locationEditBtn.addEventListener('click', (e) => editCopiedLocation(newRow, locationId));
        }
        newRow.appendChild(newCell);
    });
    currentRow.after(newRow);
}
function editCopiedLocation(newRow, locationId) {
    const content = newRow.querySelectorAll('.editable-wrapper');
    let locData = {
        einrichtungbezeichnung: '',
        fensterzeile: '',
        telefon: '',
        telefax: '',
    };
    content.forEach((el) => {
        var _a, _b;
        const value = (_b = (_a = el.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '';
        let key = el.getAttribute('data-key');
        if (!key || key && !(key in locData) || value == '') {
            DomHelper.showMessage({
                appcn: "",
                appdn: "",
                duration: 5000,
                header: "Error",
                icon: "fa-circle-exclamation",
                message: `Kopier Zeile konnte nicht beschrieben werden`,
                type: 'error',
                version: ""
            }, null, dataStore.getBearerToken());
            return;
        }
        locData[key] = value;
    });
    let copiedLocation = dataStore.getCopiedLocation();
    if (!copiedLocation) {
        DomHelper.showMessage({
            appcn: "",
            appdn: "",
            duration: 5000,
            header: "Error",
            icon: "fa-circle-exclamation",
            message: `Ein unerwarteter Fehler ist passiert`,
            type: 'error',
            version: ""
        }, null, dataStore.getBearerToken());
        return;
    }
    copiedLocation.einrichtungbezeichnung = locData['einrichtungbezeichnung'];
    copiedLocation.standort = locData['standort'];
    copiedLocation.fensterzeile = locData['fensterzeile'];
    copiedLocation.telefon = locData['telefon'];
    copiedLocation.telefax = locData['telefax'];
    dataStore.setCopiedLocation(copiedLocation);
    console.log(copiedLocation);
    insertLocationDataIntoEditor(copiedLocation, true);
}
function insertLocationDataIntoEditor(locationData, dirtyFlag = false) {
    const odOfficeFacilitySelector = document.getElementById('odOfficeFacilitySelector');
    const odOfficeLocations = document.getElementById('odOfficeLocations');
    const odTemplateEditor = document.getElementById('odTemplateEditor');
    const odTemplate = document.getElementById('odTemplate');
    odOfficeFacilitySelector.classList.add('disabled');
    odOfficeLocations.classList.add('disabled');
    odTemplateEditor.classList.remove('disabled');
    const all = odTemplateEditor.querySelectorAll("*");
    const dataFields = Array.from(all).filter((el) => Object.keys(el.dataset).length > 0);
    dataFields.forEach((el) => {
        const dataKeys = Object.keys(el.dataset);
        dataKeys.forEach((key) => {
            let value = locationData[key];
            console.log(`Key: ${key}: Value of Location: ${value}`);
            if (value && value.match(/IBAN:/)) {
                value = replaceSpaceWithNbsp(value);
            }
            if (value == null) {
                value = '(Leer)';
            }
            el.innerHTML = value;
            el.dataset[key] = value;
            el.setAttribute('contenteditable', 'true');
            el.addEventListener('input', (e) => onDataContentChange(e, key, odTemplate));
        });
    });
    odTemplate.setAttribute('table-facility', `${locationData.einrichtungid}`);
    odTemplate.setAttribute('table-location', `${locationData.standortid}`);
    odTemplate.setAttribute('table-address', `${locationData.anschriftid}`);
    odTemplate.setAttribute('table-fuss', `${locationData.fussid}`);
    odTemplate.setAttribute('dirty-flag', `${dirtyFlag}`);
}
function onDataContentChange(e, key, odTemplate) {
    const element = e.target;
    element.dataset[key] = element.innerHTML;
    if (odTemplate.getAttribute('dirty-flag') === 'false') {
        odTemplate.setAttribute('dirty-flag', 'true');
        const odTemplateSaveButton = document.getElementById('odTemplateSaveButton');
        odTemplateSaveButton.disabled = false;
    }
}
function saveEditorChanges(e) {
    const all = document.getElementById('odTemplateEditor').querySelectorAll("*");
    const dataFields = Array.from(all).filter((el) => Object.keys(el.dataset).length > 0);
    const odTemplate = document.getElementById('odTemplate');
    let locBuild = {};
    dataFields.forEach((el) => {
        const key = Object.keys(el.dataset)[0];
        let value = el.dataset[key];
        locBuild[key] = prepareValue(value);
    });
    locBuild['einrichtungid'] = Number(odTemplate.getAttribute('table-facility'));
    locBuild['standortid'] = Number(odTemplate.getAttribute('table-location'));
    locBuild['anschriftid'] = Number(odTemplate.getAttribute('table-address'));
    locBuild['fussid'] = Number(odTemplate.getAttribute('table-fuss'));
    const loc = locBuild;
    sendOfficeBackendData("/locations/" + loc.einrichtungid + "/update", "PUT", "application/json", dataStore.getBearerToken(), loc, function (response) {
        const responseData = JSON.parse(response.target.response);
        console.log(responseData);
        odTemplate.setAttribute('dirty-flag', 'false');
        dataStore.setIsLocationUpdated(true);
        if (dataStore.isCopyInProgress()) {
            dataStore.setCopiedLocation(null);
        }
    });
}
function updateRow(locationId) {
    const tbody = document.getElementById("rudi-officedb-table-body");
    let targetRow = tbody === null || tbody === void 0 ? void 0 : tbody.querySelector(`[id="${locationId}"]`);
    if (!targetRow) {
        console.error("updateRow{} -- targetRow not found");
        return;
    }
    targetRow.style.background = 'red';
}
function replaceSpaceWithNbsp(str) {
    return str.replace(/\s+/g, '&nbsp;');
}
function prepareValue(value) {
    if (value) {
        if (value === "null" || value === "(Leer)") {
            return null;
        }
        if (value === "undefined") {
            return undefined;
        }
        return value.replace(/&nbsp;/g, ' ').replace(/<br>/g, '');
    }
    return undefined;
}
function filterTable(tbody, query) {
    const rows = tbody.querySelectorAll('tr');
    rows.forEach(row => {
        var _a, _b;
        const rowText = (_b = (_a = row.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "";
        if (query === '' || rowText.includes(query)) {
            row.classList.remove('disabled');
        }
        else {
            row.classList.add('disabled');
        }
    });
}
function renderTemplateEditor(injectNode) {
    const template = DomHelper.appendNode(injectNode, 'div', ['template'], [], '', 'odTemplate');
    const templateHeader = DomHelper.appendNode(template, 'h3', ['template-header']);
    const headerRight = DomHelper.appendNode(templateHeader, 'div', ['header-right']);
    DomHelper.appendNode(headerRight, 'img', ['logo'], [{ attr: 'alt', value: 'Kein Logo gefunden' }], '', 'template-logo');
    const locationText = DomHelper.appendNode(headerRight, 'div', ['location-text']);
    DomHelper.appendNode(locationText, 'strong', [], [{ attr: 'data-einrichtungbezeichnung', value: '' }], 'Loading...');
    DomHelper.appendNode(locationText, 'br', []);
    DomHelper.appendNode(locationText, 'p', [], [{ attr: 'data-zusatz', value: '' }], 'Loading...');
    const templateAddressArea = DomHelper.appendNode(template, 'div', ['template-address-area']);
    const fensterEdit = DomHelper.appendNode(templateAddressArea, 'div', ['editable-wrapper']);
    DomHelper.appendNode(fensterEdit, 'i', ['fa-light', 'fa-pen']);
    DomHelper.appendNode(fensterEdit, 'div', [], [{ attr: 'data-fensterzeile', value: '' }], 'Loading...', 'return-address');
    const addressField = DomHelper.appendNode(templateAddressArea, 'div', ['address-field']);
    DomHelper.appendNode(addressField, 'div', ['template-placeholder-box']);
    const templateContactGrid = DomHelper.appendNode(template, 'div', ['template-contact-grid']);
    renderContactItem(templateContactGrid, 'Ihr Zeichen');
    renderContactItem(templateContactGrid, 'Unser Zeichen');
    renderContactItem(templateContactGrid, 'Telefon', 'telefon');
    renderContactItem(templateContactGrid, 'E-Mail', 'email');
    renderContactItem(templateContactGrid, 'Ihr Schreiben vom');
    renderContactItem(templateContactGrid, 'Name');
    renderContactItem(templateContactGrid, 'Fax', 'telefax');
    renderContactItem(templateContactGrid, 'Datum');
    const templateBody = DomHelper.appendNode(template, 'div', ['template-body']);
    DomHelper.appendNode(templateBody, 'h2', ['subject'], [], '[Betreff hier eingeben]');
    DomHelper.appendNode(templateBody, 'p', ['salutation'], [], 'Sehr geehrte');
    const templateFooter = DomHelper.appendNode(template, 'div', ['template-footer']);
    const footerColOne = DomHelper.appendNode(templateFooter, 'div', ['footer-col']);
    DomHelper.appendNode(footerColOne, 'p', [], [{ attr: 'data-fuss11', value: '' }], 'Loading');
    DomHelper.appendNode(footerColOne, 'p', [], [{ attr: 'data-fuss21', value: '' }], 'Loading');
    DomHelper.appendNode(footerColOne, 'p', [], [{ attr: 'data-fuss31', value: '' }], 'Loading');
    DomHelper.appendNode(footerColOne, 'p', [], [{ attr: 'data-fuss41', value: '' }], 'Loading');
    DomHelper.appendNode(footerColOne, 'p', [], [{ attr: 'data-fuss51', value: '' }], 'Loading');
    const footerColTwo = DomHelper.appendNode(templateFooter, 'div', ['footer-col']);
    DomHelper.appendNode(footerColTwo, 'p', [], [{ attr: 'data-fuss12', value: '' }], 'Loading');
    DomHelper.appendNode(footerColTwo, 'p', [], [{ attr: 'data-fuss22', value: '' }], 'Loading');
    DomHelper.appendNode(footerColTwo, 'p', [], [{ attr: 'data-fuss32', value: '' }], 'Loading');
    DomHelper.appendNode(footerColTwo, 'p', [], [{ attr: 'data-fuss42', value: '' }], 'Loading');
    DomHelper.appendNode(footerColTwo, 'p', [], [{ attr: 'data-fuss52', value: '' }], 'Loading');
    const footerColThree = DomHelper.appendNode(templateFooter, 'div', ['footer-col']);
    DomHelper.appendNode(footerColThree, 'p', [], [{ attr: 'data-fuss13', value: '' }], 'Loading');
    DomHelper.appendNode(footerColThree, 'p', [], [{ attr: 'data-fuss23', value: '' }], 'Loading');
    DomHelper.appendNode(footerColThree, 'p', [], [{ attr: 'data-fuss33', value: '' }], 'Loading');
    DomHelper.appendNode(footerColThree, 'p', [], [{ attr: 'data-fuss43', value: '' }], 'Loading');
    DomHelper.appendNode(footerColThree, 'p', [], [{ attr: 'data-fuss53', value: '' }], 'Loading');
    const footerColFour = DomHelper.appendNode(templateFooter, 'div', ['footer-col']);
    DomHelper.appendNode(footerColFour, 'p', [], [{ attr: 'data-fuss14', value: '' }], 'Loading');
    DomHelper.appendNode(footerColFour, 'p', [], [{ attr: 'data-fuss24', value: '' }], 'Loading');
    DomHelper.appendNode(footerColFour, 'p', [], [{ attr: 'data-fuss34', value: '' }], 'Loading');
    DomHelper.appendNode(footerColFour, 'p', [], [{ attr: 'data-fuss44', value: '' }], 'Loading');
    DomHelper.appendNode(footerColFour, 'p', [], [{ attr: 'data-fuss54', value: '' }], 'Loading');
    const footerColFive = DomHelper.appendNode(templateFooter, 'div', ['footer-col']);
    DomHelper.appendNode(footerColFive, 'p', [], [{ attr: 'data-fuss15', value: '' }], 'Loading');
    DomHelper.appendNode(footerColFive, 'p', [], [{ attr: 'data-fuss25', value: '' }], 'Loading');
    DomHelper.appendNode(footerColFive, 'p', [], [{ attr: 'data-fuss35', value: '' }], 'Loading');
    DomHelper.appendNode(footerColFive, 'p', [], [{ attr: 'data-fuss45', value: '' }], 'Loading');
    DomHelper.appendNode(footerColFive, 'p', [], [{ attr: 'data-fuss55', value: '' }], 'Loading');
    const templateActionButtons = DomHelper.appendNode(injectNode, 'div', ['template-action-buttons']);
    const backButton = DomHelper.appendNode(templateActionButtons, 'button', ['btn', 'btn-primary']);
    DomHelper.appendNode(backButton, 'i', ['fa-light', 'fa-arrow-left'], []);
    DomHelper.appendNode(backButton, 'span', [], [], 'Zurück');
    const saveButton = DomHelper.appendNode(templateActionButtons, 'button', ['btn', 'btn-primary'], [], '', 'odTemplateSaveButton');
    saveButton.disabled = true;
    const icon = DomHelper.appendNode(saveButton, 'i', ['fa-regular', 'fa-floppy-disk']);
    const text = DomHelper.appendNode(saveButton, 'span', [], [], 'Speichern');
    DomHelper.addToolTip(icon, 'Speichern Sie die Änderungen');
    addTemplateMutationObserver(template, saveButton);
    backButton.addEventListener('click', () => exitTemplateEditor(template));
    saveButton.addEventListener('click', (e) => saveEditorChanges(e));
}
function addTemplateMutationObserver(injectNode, saveButton) {
    const observerCallback = (mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'dirty-flag') {
                const isDirty = injectNode.getAttribute('dirty-flag') === 'true';
                saveButton.disabled = !isDirty;
                console.log(`Dirty-Flag geändert: ${isDirty}. Button ist jetzt ${saveButton.disabled ? 'deaktiviert' : 'aktiviert'}.`);
            }
        }
    };
    const observer = new MutationObserver(observerCallback);
    observer.observe(injectNode, {
        attributes: true,
        attributeFilter: ['dirty-flag']
    });
}
function renderContactItem(injectNode, label, value) {
    const contactItem = DomHelper.appendNode(injectNode, 'div', ['contact-item'], [], '');
    DomHelper.appendNode(contactItem, 'label', [], [], label);
    if (value) {
        const span = DomHelper.appendNode(contactItem, 'span', [], [{ attr: `data-${value}`, value: '' }]);
        DomHelper.appendNode(span, 'div', ['template-placeholder-line', 'short']);
    }
    DomHelper.appendNode(contactItem, 'div', ['template-placeholder-line', 'short']);
}
function exitTemplateEditor(template) {
    if (dataStore.isCopyInProgress()) {
        DomHelper.showMessage({
            appcn: "",
            appdn: "",
            duration: 5000,
            header: "Error",
            icon: "fa-circle-exclamation",
            message: `Nach einem Kopiervorgang müssen Sie die Änderung speichern.`,
            type: 'error',
            version: ""
        }, null, dataStore.getBearerToken());
        return;
    }
    if (template.getAttribute('dirty-flag') === 'true') {
        if (!confirm('Ungespeicherte Änderungen. Soll der Editor wirklich geschlossen werden?')) {
            return;
        }
    }
    if (dataStore.getIsLocationUpdated()) {
        const tbody = document.getElementById('rudi-officedb-table-body');
        const facilityId = tbody.getAttribute('table-facility');
        getOfficeBackendData("/facilities/" + facilityId + "/locations", "GET", "application/json", dataStore.getBearerToken(), function (response) {
            const responseData = JSON.parse(response.target.response);
            console.log(responseData);
            injectDataToLocationTable(tbody, responseData);
            dataStore.setIsLocationUpdated(false);
        });
    }
    console.log("After getBackend");
    const odOfficeFacilitySelector = document.getElementById('odOfficeFacilitySelector');
    const odOfficeLocations = document.getElementById('odOfficeLocations');
    const odTemplateEditor = document.getElementById('odTemplateEditor');
    odOfficeFacilitySelector.classList.remove('disabled');
    odOfficeLocations.classList.remove('disabled');
    odTemplateEditor.classList.add('disabled');
    clearDataFields(template);
}
function clearDataFields(template) {
    const all = document.getElementById('odTemplateEditor').querySelectorAll("*");
    const dataFields = Array.from(all).filter((el) => Object.keys(el.dataset).length > 0);
    dataFields.forEach((el) => {
        const dataKeys = Object.keys(el.dataset);
        dataKeys.forEach((key) => {
            el.dataset[key] = '';
            el.innerText = '';
        });
    });
    template.setAttribute('table-facility', '');
    template.setAttribute('table-location', '');
    template.setAttribute('table-address', '');
    template.setAttribute('table-fuss', '');
    template.setAttribute('dirty-flag', 'false');
}
